



















    import Vue from 'Vue';
    export default Vue.extend({
        name: 'side-panel',
        props: { initialShowPanel: Boolean, contentClass: String, position: String, id: { type: String, required: true }, rightSmallScreenSafe: Boolean },
        data: function () {
            return { showPanel: this.initialShowPanel };
        },
        methods: {
            expandoClicked ():void {
                this.showPanel = !this.showPanel;
                this.$emit('expandoClicked', { show: this.showPanel });
            },
            transitionCompleteHandler(): void {
                this.$emit('transitionComplete', { show: this.showPanel });
            }
        },
        mounted: function () {
            this.$nextTick(function () { //all the dom elements will be available now so attach events
                var el = document.getElementById(this.id + '_content');
                el.addEventListener('transitionend', this.transitionCompleteHandler.bind(this), true);
            });
        },
        computed: {
            positionClass (): any {
                return {
                    'widget-pane-left-toggle-button-container': this.position === 'left',
                    'widget-pane-right-toggle-button-container': this.position != 'left',
                    'widget-pane-toggle-button-container': !this.useSmallScreenOption,
                    'widget-pane-toggle-button-container-small-screens': this.useSmallScreenOption
                }
            },
            expandoClass() : any{
                var retVal = { 'widgetPaneCollapsed': this.showPanel };
                if (this.position === 'left') {
                    retVal = { 'widgetPaneCollapsed': this.showPanel ? false : true };
                }
                else {
                    retVal = { 'widgetPaneCollapsed': this.showPanel ? true : false };
                }
                return retVal;
            },
            contentCss() : string{
                return this.contentClass;
            },
            contentId(): string {
                return this.id + '_content';
            },
            useSmallScreenOption(): boolean {
                return this.rightSmallScreenSafe && this.$vuetify.breakpoint.smAndDown;
            }
        }
    });
